/** How a linked account is named: its @handle, except Facebook Pages, whose names are not handles. */
export function socialAccountName(connection: { platform: string; username: string }): string {
  return connection.platform === 'facebook' ? connection.username : `@${connection.username}`;
}
